module.exports = __webpack_public_path__ + "static/media/27.62fb2a1f.wav";